import dayjs from "dayjs";
import { getAverageScore, round } from "utils";

/**
 * Maps `getInterviewAttempts` results into the shape the mobile AttemptCard
 * needs. Replicates the desktop AttemptsTable column logic exactly.
 */
export function mapAttempts(interviewAttempts = []) {
  return interviewAttempts.map((a) => {
    const communication = round(a.analysis?.communication?.ratings?.OVERALL) || 0;
    const content = round(a.analysis?.content?.ratings?.OVERALL) || 0;

    const rawType = a?.interviewTemplate?.type;
    const typeLabel =
      rawType === "personalized" ? "Mock Interview" : (rawType || "").replace(/_/g, " ");

    let timeLabel = "N/A";
    if (a.finishedAt && a.startedAt) {
      const seconds = dayjs(a.finishedAt).diff(a.startedAt, "seconds");
      timeLabel = seconds < 60 ? `${seconds} secs` : `${round(seconds / 60)} mins`;
    }

    return {
      id: a._id,
      title: a?.interviewTemplate?.name || "Assessment",
      type: rawType, // lowercase — used for filtering
      typeLabel,
      timeLabel,
      date: dayjs(a.createdAt).format("DD/MM/YYYY"),
      score: round(getAverageScore(communication, content)),
      speech: communication,
      content,
    };
  });
}
